import { Link } from "wouter";
import Layout, { PageHeader } from "@/components/Layout";
import { Button } from "@/components/ui/Buttons";
import { Card } from "@/components/ui/Cards";

export default function NotFound() {
  return (
    <Layout>
      <PageHeader title="404" subtitle="That page doesn't exist." />
      <div className="p-8 max-w-3xl">
        <Card>
          <p className="text-sm text-white">Couldn't find what you were looking for.</p>
          <p className="mt-1 text-xs" style={{ color: "#6B7280" }}>
            Use the sidebar to navigate, or jump back to the dashboard.
          </p>
          <div className="mt-4">
            <Link href="/">
              <Button variant="primary" size="sm">
                Back to Dashboard
              </Button>
            </Link>
          </div>
        </Card>
      </div>
    </Layout>
  );
}
